import { api } from "./apiClient";

const clubSupportAPI = {
  getSupportMessages(params) {
    return api.get("/club-support/messages", { params }).then((r) => r.data);
  },
  sendSupportMessage(body) {
    return api.post("/club-support/messages", body).then((r) => r.data);
  },
  getSupportUnread() {
    return api.get("/club-support/unread").then((r) => r.data);
  },
  uploadSupportMedia(file) {
    const form = new FormData();
    form.append("file", file);
    return api
      .post("/club-support/upload", form, {
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then((r) => r.data);
  },
};

export default clubSupportAPI;
